module.exports = __webpack_public_path__ + "img/pc_banner_privacy.11fa6892.jpeg";